$(document).ready(function () {
  $('[data-toggle="tooltip"]').tooltip();

  // Auto play iphone safari banner video
   document.addEventListener('DOMContentLoaded', function() {
    var video = document.getElementById('bannerVideo');
    video.muted = true; // Bắt buộc video im lặng để autoplay hoạt động trên iOS
    video.play();
    video.addEventListener('ended', function() {
      video.currentTime = 0;
      video.play();
    });
  });

  // Tab Append
  $(".appendtabfea").appendTo("#tab-fea-0");
  $(".appendtablatest").appendTo("#tab-latest-0");
  $(".appendtabbest").appendTo("#tab-best-0");

  // Slideshow
  $(".owl-slider").slick({
    slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
dots: true,
    arrows: false,
  });

  // Special Product
  $(".owl-catt").slick({
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1410,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
  $(".owl-catt").show();

  // Special Product
  $(".wbspeprod").slick({
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".wbspeprod").show();

  // Countdown Timer
  $("[data-countdown]").each(function () {
    var $this = $(this),
      finalDate = $(this).data("countdown");
    Date.prototype.yyyymmdd = function () {
      var yyyy = this.getFullYear().toString();
      var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
      var dd = this.getDate().toString();
      return (
        yyyy +
        "/" +
        (mm[1] ? mm : "0" + mm[0]) +
        "/" +
        (dd[1] ? dd : "0" + dd[0])
      ); // padding
    };
    var date = new Date();
    if (finalDate > date.yyyymmdd()) {
      $(this).parents(".timer_outer").css("display", "block");
    } else {
      $(this).parents(".timer_outer").css("display", "none");
    }
    $this.countdown(finalDate, function (event) {
      $this.html(
        event.strftime(
          "<span>%D</span><span>%H</span><span>%M</span><span>%S</span>"
        )
      );
    });
  });

  // Home Tab Product
  $(".wbfea,.wbnew,.wbbest,.wbtopr").slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
  $(".wbfea").show();
  $(".wbnew").show();
  $(".wbbest").show();
  $(".wbtopr").show();

  // Testimonial
  $(".testi").slick({
    dots: true,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $(".testi").show();

  // Blog
  $(".wbblog").slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".wbblog").show();

  // Logo Slider
  $(".wblogobar").slick({
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1410,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
  $(".wblogobar").show();

  // Scroll To top
  $("#scroll").addClass("scrollhide");
  $(window).scroll(function () {
    if ($(this).scrollTop() === 0) {
      $("#scroll").addClass("scrollhide");
    } else {
      $("#scroll").removeClass("scrollhide");
    }
  });
  $("#scroll").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

  // Mobile Menu Toggle
  if ($(window).width() <= 991) {
    $(".wbmegamainhd").on("click", function () {
      var targetMenu = "#" + $(this).data("submenu");
      $(targetMenu).slideToggle(300);
      $(this).toggleClass("active");
      return false;
    });
    $("#megamenu").prependTo(".headlogo");
  }
  if ($(window).width() <= 767) {
    $("localization-form").appendTo(".customer_account ul");
  }

  // Collection Grid/List View
  $(document).on("click", ".wblistgridbtn", function (e) {
    $(this).addClass("active").siblings().removeClass("active");
    if ($(this).hasClass("listv")) {
      $("#product-grid").addClass("product-list").removeClass("product-grid");
    } else if ($(this).hasClass("gridv")) {
      $("#product-grid").addClass("product-grid").removeClass("product-list");
    }
  });

  // Popup Product
  $(".wbpopup-popducts .popinner").hide();
  var i = 0;
  setIntervalFun();
  var totalTimer = parseInt(3000) + parseInt(2000);
  setInterval(setIntervalFun, totalTimer);
  function setIntervalFun() {
    $(".wbpopup-popducts .popinner").eq(i).fadeIn(400);
    setTimeout(function () {
      $(".wbpopup-popducts .popinner").eq(i).fadeOut(400);
      i++;
      if ($(".wbpopup-popducts .popinner").length <= i) {
        i = 0;
      }
    }, parseInt(7000));
  }
  $(document).on("click", ".wbclosepopup", function () {
    $(".wbpopup-popducts").fadeOut(400).remove();
  });

  // Box Layout
  $(".wbboxdemo").click(function () {
    $(".wbboxlt").attr("id", "wbboxlayout");
  });
  $(".wbwidedemo").click(function () {
    $(".wbboxlt").removeAttr("id");
  });
  // Color Customizer
  $("body").on("click", ".wbinnerclr a", function (e) {
    e.preventDefault();
    $(".wbinnerclr").find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbcolorname=""]').remove();
    if (!$(this).hasClass($("html").attr("")))
      $("body").append(
        '<link rel="stylesheet" type="text/css" wbcolorname href="' +
          $(this).attr("href") +
          '">'
      );
  });
  // Rtl Mode
  $("body").on("click", ".wbrtlmode a", function (e) {
    e.preventDefault();
    $(".wbrtlmode").find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbrtl=""]').remove();
    if (!$(this).hasClass($("html").attr("")))
      $("body").append(
        '<link rel="stylesheet" type="text/css" wbrtl href="' +
          $(this).attr("href") +
          '">'
      );
  });
  // Color Open/Close
  $(".wbopen-closeclr").click(function () {
    if ($(this).hasClass("wbclrdisable")) {
      $(this).removeClass("wbclrdisable");
      $(this).addClass("wbclrenable");
      $(".wbcolor_box").animate({ right: "30px" }, 450);
      $(".wbcolor_box").css({
        "box-shadow": "0 10px 35px 10px rgba(0,0,0,.06)",
        background: "#fff",
        "border-radius": "4px 0 4px 4px",
      });
      $(".wbcolor_option,.wbcolor_title").animate({ opacity: "1" }, 450);
    } else {
      $(this).removeClass("wbclrenable");
      $(this).addClass("wbclrdisable");
      $(".wbcolor_box").animate({ right: "-250px" }, 450);
      $(".wbcolor_box").css({
        "box-shadow": "none",
        background: "transparent",
      });
      $(".wbcolor_option,.wbcolor_title").animate({ opacity: "0" }, 450);
    }
  });
}); // Document Ready Div End

$(window).on("load", function () {
  $(".s-panel .loader").removeClass("wrloader");
});

// Menu For Mobile
function w3_open() {
  document.getElementById("myOverlay").style.display = "block";
  document.getElementById("megamenu").className = "active";
  $("body").addClass("wbbodyscroll");
}
function w3_close() {
  document.getElementById("myOverlay").style.display = "none";
  document.getElementById("megamenu").className = "";
  $("body").removeClass("wbbodyscroll");
}
